let initialState = {
    loading: false
}

const loadingReducer = (state = initialState, action:any) => {
    let {type, payload} = action
    switch (type) {
        case 'TOOGLE_LOADING':
            return payload
        default:
            return state
    }
}

export default loadingReducer